import { Box, Tooltip } from '@mui/material';
import DateFormatter from '@apigrowfinance/pbolt-date-formatter';
import { useIntl } from 'react-intl';

import accountTimelineCategory from '@messages/accountTimelineCategory';
import accountTimelineCategoryDesc from '@messages/accountTimelineCategoryDesc';
import accountTimelineType from '@messages/accountTimelineType';
import { isItToday } from '@utils/dateUtil';
import getEnumTranslation from '@utils/getEnumTranslation';

export type TimelineItemCardProps = {
    timestamp?: string;
    type?: string;
    category?: string;
    showTooltip?: boolean;
};

const TransactionOneLiner = ({
    timestamp = '',
    type = '',
    category = '',
    showTooltip = true,
}: TimelineItemCardProps) => {
    const { formatMessage } = useIntl();

    const titleText = type
        ? getEnumTranslation(type, {
              messages: accountTimelineType,
          })
        : '';

    const categoryText = category
        ? getEnumTranslation(category, {
              messages: accountTimelineCategory,
              formatMessage,
          })
              .toString()
              .toLowerCase()
        : '';

    const tooltipText = category
        ? getEnumTranslation(category + '_DESC', {
              messages: accountTimelineCategoryDesc,
              formatMessage,
          })
        : '';

    const today = formatMessage({
        id: 'date.today',
        defaultMessage: 'Today',
    });

    return (
        <Box data-testid="timeline-oneliner" component="span">
            {isItToday(timestamp) && today + ' • '}
            <DateFormatter date={timestamp} format="shortDateWithTimeArb" />
            {' • '}
            {category === '' ? (
                <>{titleText}</>
            ) : (
                <>
                    {showTooltip ? (
                        <Tooltip
                            title={tooltipText}
                            PopperProps={{
                                modifiers: [
                                    {
                                        name: 'offset',
                                        options: {
                                            offset: [0, -10],
                                        },
                                    },
                                ],
                            }}>
                            <Box
                                component="span"
                                data-testid="category-tooltip"
                                sx={{
                                    textDecoration: 'underline',
                                    textDecorationStyle: 'dotted',
                                }}>
                                {titleText} {categoryText}
                            </Box>
                        </Tooltip>
                    ) : (
                        <Box component="span">
                            {titleText} {categoryText}
                        </Box>
                    )}
                </>
            )}
        </Box>
    );
};

export default TransactionOneLiner;
